import type {Request} from "express";

import {isNumber, range} from "@pg-mono/nodash";

export const getAbTestVariantFromQuery = (id: string, variants: number, sampling: boolean, req?: Partial<Request>): number | null => {
    if (req?.query?.ab_test_experiment && req.query.ab_test_experiment === id) {
        const variant = parseInt(req.query.ab_test_variant as string, 10);

        if (isNumber(variant, true)) {
            return range(sampling ? -1 : 0, variants + 1).includes(variant) ? variant : null;
        }
    }

    return null;
};
import type {Request} from "express";

import {isNumber, range} from "@pg-mono/nodash";

export const getAbTestVariantFromQuery = (id: string, variants: number, sampling: boolean, req?: Partial<Request>): number | null => {
    if (req?.query?.ab_test_experiment && req.query.ab_test_experiment === id) {
        const variant = parseInt(req.query.ab_test_variant as string, 10);

        if (isNumber(variant, true)) {
            return range(sampling ? -1 : 0, variants + 1).includes(variant) ? variant : null;
        }
    }

    return null;
};
